import { __module as e } from "../../../_virtual/isSemVer.js";
import { a as t } from "./util/assertString.js";
import { m as r } from "./util/multilineRegex.js";
!function (e, a) {
  Object.defineProperty(a, "__esModule", {
    value: !0
  }), a.default = function (e) {
    return (0, u.default)(e), s.test(e);
  };
  var u = o(t);
  function o(e) {
    return e && e.__esModule ? e : {
      default: e
    };
  }
  var s = (0, o(r).default)(["^(0|[1-9]\\d*)\\.(0|[1-9]\\d*)\\.(0|[1-9]\\d*)", "(?:-((?:0|[1-9]\\d*|\\d*[a-z-][0-9a-z-]*)(?:\\.(?:0|[1-9]\\d*|\\d*[a-z-][0-9a-z-]*))*))", "?(?:\\+([0-9a-z-]+(?:\\.[0-9a-z-]+)*))?$"], "i");
  e.exports = a.default, e.exports.default = a.default;
}(e, e.exports);
var a = e.exports;
export { a as i };